import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { readLocalThemeVariant } from 'lib/styles';
import { AuthAction } from 'store/auth';
import { Config } from 'types/config';
import { ThemeVariant } from 'types/styles';
import { SystemAction } from './actions';

const configReducer = createReducer<Nullable<Config>>(null).handleType(
  SystemAction.Config,
  (state, action) => action.payload,
);

const initializedReducer = createReducer<boolean>(false).handleType(
  SystemAction.Initialized,
  () => true,
);

const themeReducer = createReducer<ThemeVariant>(readLocalThemeVariant()).handleType(
  SystemAction.Theme,
  (state, action) => action.payload,
);

const unauthorizedReducer = createReducer<boolean>(false)
  .handleType(AuthAction.Success, () => false)
  .handleType(SystemAction.Unauthorized, () => true);

export default combineReducers({
  config: configReducer,
  initialized: initializedReducer,
  theme: themeReducer,
  unauthorized: unauthorizedReducer,
});
